'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../../../../node_modules/@radix-ui/react-popover/dist/index.cjs');
var React = require('react');
var Content_web_styles = require('./Content.web.styles.cjs');

/**
 * Popover content container component
 *
 * {@link https://aviary.fullscript.io/latest/components/popover-1-1/web-CwmN8Qt3 | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/atoms/Popover/Content/Content.web.tsx | View in GitLab}
 *
 * @scope Popover child
 */ const Content = ({ side, align, hideArrow = false, customPopoverWidth, children })=>{
    const theme = react.useTheme();
    const ref = React.useRef(null);
    const renderArrow = ()=>{
        if (!hideArrow) {
            return /*#__PURE__*/ jsxRuntime.jsx(index.Arrow, {
                css: Content_web_styles.arrow,
                width: 20,
                height: 12
            });
        }
    };
    const contentStyles = React.useMemo(()=>[
            Content_web_styles.content,
            customPopoverWidth && Content_web_styles.customWidth(customPopoverWidth)
        ], [
        theme,
        customPopoverWidth
    ]);
    return /*#__PURE__*/ jsxRuntime.jsx(index.Portal, {
        children: /*#__PURE__*/ jsxRuntime.jsx(index.Content, {
            side: side,
            align: align,
            className: "PopoverContent",
            css: Content_web_styles.radixWrapper,
            children: /*#__PURE__*/ jsxRuntime.jsxs("div", {
                css: contentStyles,
                ref: ref,
                children: [
                    renderArrow(),
                    children
                ]
            })
        })
    });
};
Content.displayName = "Popover.Content";

exports.Content = Content;
//# sourceMappingURL=Content.web.cjs.map
